import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconDelete = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" size={size} {...props}>
        <StyledPath
            color={color}
            d="M16.12 5.107v-1.48l-1.584-.748H12.22v-.14c0-1.149-.94-2.089-2.09-2.089H6.51c-1.15 0-2.09.94-2.09 2.09v.139H2.07l-1.55.748v1.48h15.6zM11.106 2.88H5.534v-.14c0-.505.47-.975.975-.975h3.622c.505 0 .975.47.975.975v.14zm2.784 13.37l.558-10.586H2.19l.56 10.586h11.14zm-2.785-1.114a.55.55 0 01-.557-.557V7.336a.55.55 0 01.557-.557.55.55 0 01.557.557v7.243a.55.55 0 01-.557.557zm-2.786 0a.55.55 0 01-.557-.557V7.336a.55.55 0 01.557-.557.55.55 0 01.557.557v7.243a.55.55 0 01-.557.557zm-2.786 0a.55.55 0 01-.557-.557V7.336a.55.55 0 01.557-.557.55.55 0 01.557.557v7.243a.55.55 0 01-.557.557z"
        />
    </StyledSvg>
);
